import { IsAllow, PlanTypes, SCHEMES_RESPONSE } from '../../../../redux-store/types/portfolio';
import {
    checkAvailableUnits,
    disablePaytmBankForGrow,
    modeOfHoldingSingle,
    notLockedFolio,
    portfoliosByAvailableUnits,
    portfoliosByDividend,
    portfoliosByRedemptionAllow,
    portfoliosByTransactionResource,
    portfoliosWithIFSC,
} from '../../portfolios/utils';
import { SwitchBy, Values } from './SwitchInvestment';
import { MAX_LENGTHS, MIN_LENGHTHS } from './types';
import en from '../../../../lang/en-us';
const { dbCommercial } = en;

enum InvestThrough {
    arn,
    ria,
    direct,
}

export function isError(formikState: any, value: string) {
    return formikState.touched[value] && formikState.errors[value];
}

export function showHelperText(formikState: any, value: string) {
    return formikState.touched[value] && !!formikState.errors[value]
        ? formikState.errors[value]
        : '';
}
//change values properties to string type
//changeType<Values,string>
type changeType<T, V> = { [K in keyof T]: V };
type errorType = Partial<changeType<Values, string>>;

export const validateHelper = (
    values: Values,
    planType: PlanTypes,
    minAmount: number,
    step: number,
) => {
    let errors: errorType = {};
    if ([PlanTypes.R, PlanTypes.Reggular].includes(planType)) {
        if (values.euin === IsAllow.YES) {
            if (!values.euinCode) {
                errors.euinCode = dbCommercial.switch.errors.EUIEmpty;
            }
        } else if (values.euin === IsAllow.No) {
            if (!values.euinDeclaration) {
                errors.euinDeclaration = dbCommercial.switch.errors.acceptEUINDeclaration;
            }
        } else {
            errors.euin = dbCommercial.switch.errors.selectEUIN;
        }
        if (
            values.arn1.length < MIN_LENGHTHS.ARN_LENGTH ||
            values.arn1.length > MAX_LENGTHS.ARN_LENGTH
        ) {
            errors.arn1 = dbCommercial.switch.errors.invalidARN;
        }
    } else {
        if (
            values.investThrough === InvestThrough.ria &&
            values.riaCode.length !== MAX_LENGTHS.RIA_LENGTH
        ) {
            errors.riaCode = dbCommercial.switch.errors.RIALength9;
        }
    }
    if (!values.redemableUnitsOrAmount && !values.switchFullAmount) {
        errors.redemableUnitsOrAmount = `${values.switchedTo} ${dbCommercial.switch.errors.empty}`;
    } else if (values.redemableUnitsOrAmount < 0) {
        errors.redemableUnitsOrAmount = `${values.switchedTo} ${dbCommercial.switch.errors.negative}`;
    } else if (values.switchedTo === SwitchBy.Amount && values.redemableUnitsOrAmount < minAmount) {
        errors.redemableUnitsOrAmount = `${values.switchedTo} ${dbCommercial.switch.errors.lessThan} ${minAmount}`;
    } else if (
        values.switchedTo === SwitchBy.Amount &&
        Math.trunc(values.redemableUnitsOrAmount % step) !== 0
    ) {
        errors.redemableUnitsOrAmount = `${values.switchedTo} ${dbCommercial.switch.errors.multiples} ${step}`;
    }
    if (!values.isChecked) {
        errors.isChecked = dbCommercial.errors.termsAndCondition;
    }
    return errors;
};

export const switchFilters: Function[] = [
    notLockedFolio,
    checkAvailableUnits,
    modeOfHoldingSingle,
    // ctPortfoliosByMinorStatus,
    portfoliosByTransactionResource,
    portfoliosByDividend,
    ({ isin }: SCHEMES_RESPONSE) => !!isin,
    ({ swtAllow }: SCHEMES_RESPONSE) => swtAllow === IsAllow.YES,
    // portfoliosWithIFSC, // Not needed for switch
];

export const stpFilters: Function[] = [
    notLockedFolio,
    checkAvailableUnits,
    modeOfHoldingSingle,
    // ctPortfoliosByMinorStatus,
    portfoliosByTransactionResource,
    portfoliosByDividend,
    ({ isin }: SCHEMES_RESPONSE) => !!isin,
    ({ stpAllow }: SCHEMES_RESPONSE) => stpAllow === IsAllow.YES,
    // portfoliosWithIFSC, // Not needed for switch
];

export const swpFilters: Function[] = [
    notLockedFolio,
    checkAvailableUnits,
    modeOfHoldingSingle,
    // ctPortfoliosByMinorStatus,
    portfoliosByTransactionResource,
    portfoliosByDividend,
    ({ isin }: SCHEMES_RESPONSE) => !!isin,
    ({ swpAllow }: SCHEMES_RESPONSE) => swpAllow === IsAllow.YES,
    // portfoliosWithIFSC, // Not needed for switch
];

export const redemptionFilters: Function[] = [
    notLockedFolio,
    // portfoliosWithIFSC,
    modeOfHoldingSingle,
    portfoliosByTransactionResource,
    // portfoliosByClosingBalance,
    portfoliosByDividend,
    portfoliosByAvailableUnits,
    disablePaytmBankForGrow,
    portfoliosByRedemptionAllow,
];
